<template>
  <div :aria-label="label" class="pills" role="group">
    <button v-for="item in items" :key="String(item.value)" :aria-pressed="String(isActive(item.value))"
            :class="{ 'pill--active': isActive(item.value) }" class="pill" type="button" @click="toggle(item.value)">
      <v-icon v-if="isActive(item.value)" class="pill__icon" x-small>mdi-check</v-icon>
      <v-icon v-else-if="item.icon" class="pill__icon" x-small>{{ item.icon }}</v-icon>
      {{ item.text }}
    </button>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export type PillItem = { value: unknown; text: string; icon?: string };

/**
 * Soft pill toggles without borders (multiple choice by default)
 */
export default Vue.extend({
  props: {
    value: {type: Array as () => unknown[], default: () => []},
    items: {type: Array as () => PillItem[], required: true},
    label: {type: String, default: ''},
  },
  methods: {
    isActive(value: unknown): boolean {
      return this.value.includes(value);
    },
    toggle(value: unknown) {
      this.$emit('input', this.isActive(value) ? this.value.filter((el) => el !== value) : [...this.value, value]);
    },
  },
});
</script>

<style>
.pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 16px;
  background: rgba(15, 23, 42, .05);
  color: rgba(15, 23, 42, .75);
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background .15s ease, color .15s ease;
}

.pill:hover {
  background: rgba(15, 23, 42, .09);
}

.pill:focus-visible {
  outline: 2px solid #1976D2;
  outline-offset: 1px;
}

.pill--active {
  background: #E3F2FD;
  color: #0D47A1;
}

.pill--active:hover {
  background: #D3E9FC;
}

.pill .pill__icon {
  color: inherit !important;
}

.theme--dark .pill {
  background: rgba(255, 255, 255, .08);
  color: rgba(255, 255, 255, .78);
}

.theme--dark .pill--active {
  background: rgba(144, 202, 249, .18);
  color: #90CAF9;
}
</style>
